import React, { useState } from "react";

import FaqItem from "./FaqItem";

const Faq = ({ questionsList }) => {
  const [open, setOpen] = useState(false);
  const toggle = (index) => {
    if (open === index) {
      return setOpen(null);
    }
    setOpen(index);
  };

  return (
    <div className="bg-primary">
      <div className=" pb-4 text-black max-w-screen-xl mx-auto  bg-primary ">
        <div>
          <h1 className="text-4xl  sm:text-7xl font-bold text-center  p-4">
            FAQ's
          </h1>
        </div>
        <div className="hover:cursor-pointer max-w-screen-xl mx-auto">
          {questionsList.map((data, index) => {
            return (
              <FaqItem
                bottomBorder={index === questionsList.length - 1 ? false : true}
                question={data.question}
                answer={data.answer}
                key={index}
                open={index === open}
                toggle={() => toggle(index)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Faq;
